import './SliderNotchLabel.8c7904e0aaa4db3bed2188642e09864d.css';
export default {"container":"_container_jv9tc_1","label":"_label_jv9tc_1"};